// extracted by mini-css-extract-plugin
module.exports = {"failedContainer":"Failed_failedContainer__3Y_7d","extraCopy":"Failed_extraCopy__3Ijfp","icon":"Failed_icon__3NLOs"};